<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Despesa</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip title="Cadastrar" v-if="getPermission('despesa.store')"><i class="fa fa-plus"></i></a></li>
                                    <li><a @click="onFilterReset()" v-b-tooltip title="Atualizar listagem"><i class="ft-rotate-cw"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                    <li><a @click="onFaturar(2, null)" v-b-tooltip title="Faturar Títulos" v-if="getPermission('despesa.store')"><i class="fa fa-check"></i></a></li>
                                    <li><a @click="onCancelar(2, null)" v-b-tooltip title="Cancelar Títulos" v-if="getPermission('despesa.store')"><i class="fa fa-times"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData"><div class="loadingDataSpinner"><spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                                    <vuetable ref="vuetable"
                                        api-url="/api/despesa"
                                        :fields="fields"
                                        :css="css"
                                        :append-params="moreParams"
                                        track-by="despesa_id"
                                        pagination-path=""
                                        detail-row-component="despesa-detalhes"
                                        @vuetable:cell-clicked="onDetail"
                                        @vuetable:load-error="onError"
                                        @vuetable:pagination-data="onPaginationData"
                                        @vuetable:loaded="onLoaded"
                                      >
                                      <template slot="status" slot-scope="props">
                                          <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-info" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-warning" v-if="props.rowData.status.valor==3">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-danger" v-if="props.rowData.status.valor==4">{{ props.rowData.status.descr }}</span>

                                      </template>
                                      <template slot="pessoa" slot-scope="props">
                                          <span v-if="props.rowData.pessoa.pessoa_juridica">
                                              <span v-b-tooltip :title="onFormataCnpj(props.rowData.pessoa.pessoa_juridica.cnpj_base,props.rowData.pessoa.pessoa_juridica.cnpj_filial,props.rowData.pessoa.pessoa_juridica.cnpj_digito)">{{ props.rowData.pessoa.pessoa_juridica.razao_social}}</span>
                                          </span>
                                          <span v-if="props.rowData.pessoa.pessoa_fisica">
                                              <span v-b-tooltip :title="props.rowData.pessoa.pessoa_fisica.cpf">{{ nome(props.rowData.pessoa.pessoa_fisica.nome,props.rowData.pessoa.pessoa_fisica.nome_social)  }}</span>
                                          </span>
                                          <span v-if="props.rowData.pessoa.pessoa_outro">
                                              <span v-b-tooltip :title="props.rowData.pessoa.pessoa_outro.cd">{{ props.rowData.pessoa.pessoa_outro.nome}}</span>
                                          </span>
                                      </template>

                                      <template slot="tp_pessoa" slot-scope="props">
                                          {{ props.rowData.pessoa.liv_tipo_pessoa.descr }}
                                      </template>

                                      <template slot="conta_bancaria" slot-scope="props">
                                          {{ props.rowData.unidade_conta.descr }}
                                      </template>

                                      <template slot="conta_contabil" slot-scope="props">
                                          {{ props.rowData.conta_contabil.descr }}
                                      </template>

                                      <template slot="actions" slot-scope="props">
                                        <div class="custom-actions">
                                            <a @click="onEdit(props.rowData, props.rowIndex)" v-b-tooltip title="Editar" v-if="getPermission('despesa.update')&&props.rowData.status.valor==2"><i class="fa fa-edit"></i></a>
                                            <a @click="onCancelar(1, props.rowData)" v-b-tooltip title="Cancelar" v-if="getPermission('despesa.cancelar')&&props.rowData.status.valor!=4"><i class="fa fa-times"></i></a>
                                            <a @click="onFaturar(1, props.rowData)" v-b-tooltip title="Faturar" v-if="getPermission('despesa.store')&&(props.rowData.status.valor==2||props.rowData.status.valor==3)"><i class="fa fa-check"></i></a>
                                            <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                          </button>
                                        </div>
                                      </template>
                                    </vuetable>
                                </div>
                                <div class='col-md-12'>
                                    <div class="pull-left pagination-detail">
                                        <vuetable-pagination-info ref="paginationInfo"
                                                                  :css="css.pagination"
                                                                  info-class="pull-left"
                                        ></vuetable-pagination-info>
                                    </div>
                                    <div class="pull-right m-a-0">
                                        <vuetable-pagination ref="pagination"
                                                             :css="css.pagination"
                                                             @vuetable-pagination:change-page="onChangePage"
                                        ></vuetable-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Modal Component -->
        <b-modal id="modal_help"
                 ref="modal_help"
                 :title="modal_titulo"
                 close-title="Fechar"
                 v-model="showModalHelp"
                 size="lg">
            <b-container fluid class="p-a-0">
                Você pode criar titulos de despesa nesta tela, além de executar ações para controlar seu fluxo de caixa <br/>
                Ainda a opção de faturar e cancelar em lote ( Vários itens selecionados ) os títulos. Fique tranquilo! Se você selecionar um titulo que não pode ser cancelado pois já está cancelado, o sistema não efetua a duplicação do cancelamento. Da mesma forma, o faturamento também funciona desta forma, só faturando títulos que podem ser faturados!<br/>
            </b-container>
        </b-modal>

        <!-- Modal Component -->
        <b-modal id="modal_form"
                 ref="modal_form"
                 size="lg"
                 :title="modal_titulo"
                 :ok-title="modal_botao"
                 close-title="Fechar"
                 v-model="showModal"
                 :ok-disabled=form.errors.any()
             @ok="handleOk">
            <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                <b-container fluid class="p-a-0">
                    <b-row>
                        <b-col>
                            <label for="descr">Descrição * <span v-b-tooltip title="Descrição para identificar a despesa" placement="top">[?]</span></label>
                            <b-form-input type="text"
                                        placeholder="Descrição"
                                        v-model="form.descr"
                                        id="descr">
                            </b-form-input>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>
                        </b-col>
                        <b-col>
                            <label for="vlr">Valor * <span v-b-tooltip title="Valor da despesa" placement="top">[?]</span></label>
                            <input v-model.lazy="form.vlr"
                                 v-money="vlr"
                                 id="vlr"
                                 type="text"
                                 class="form-control"
                                 style="text-align: right" />
                            <b-form-feedback class="text-danger" v-text="form.errors.get('vlr')" v-if="form.errors.has('vlr')"></b-form-feedback>
                        </b-col>
                        <b-col>
                            <label for="conta_contabil">Conta Contábil * <span v-b-tooltip title="Conta contábil que será vinculado a despesa." placement="top">[?]</span></label>
                                 <multiselect v-model="form.conta_contabil"
                                 :options="optionsContaContabil"
                                 id="conta_contabil"
                                 track-by="value"
                                 label="label"
                                 :hide-selected="true"
                                 placeholder="Selecione"
                                 tag-placeholder=""
                                 select-label=""
                                 selected-label="Selecionado"
                                 deselect-label="Remover"
                                 ></multiselect>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('conta_contabil.value')" v-if="form.errors.has('conta_contabil.value')"></b-form-feedback>
                        </b-col>
                        <b-col>
                            <label for="unidade_conta">Conta Bancária * <span v-b-tooltip title="Conta bancária que o crédito irá movimentar" placement="top">[?]</span></label>
                            <multiselect v-model="form.unidade_conta"
                              :options="optionsUnidadeConta"
                              track-by="value"
                              id="unidade_conta"
                              label="label"
                              :hide-selected="true"
                              placeholder="Selecione"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('unidade_conta.value')" v-if="form.errors.has('unidade_conta.value')"></b-form-feedback>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4">
                            <label for="dt_competencia">Data Competência * <span v-b-tooltip title="Data de competência da despesa" placement="top">[?]</span></label>
                            <v-date-picker v-model="form.dt_competencia"
                                           mode='single'
                                           locale="pt-BR"
                                           v-mask="'##/##/####'"
                                           :popover='{visibility: "focus"}'
                                           :attributes='date_attributes'
                                           :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                           >
                            </v-date-picker>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('dt_competencia')" v-if="form.errors.has('dt_competencia')"></b-form-feedback>
                        </b-col>
                        <b-col cols="4">
                            <label for="dt_vencto">Data Prevista * <span v-b-tooltip title="Data prevista ( Pode ser anterior ) para recebimento" placement="top">[?]</span></label>
                            <v-date-picker v-model="form.dt_vencto"
                                           mode='single'
                                           locale="pt-BR"
                                           v-mask="'##/##/####'"
                                           :popover='{visibility: "focus"}'
                                           :attributes='date_attributes'
                                           :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                           >
                            </v-date-picker>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('dt_vencto')" v-if="form.errors.has('dt_vencto')"></b-form-feedback>
                        </b-col>
                        <b-col cols="2">
                            <label for="pago">Pago ? <span v-b-tooltip title="Indica se o valor já foi pago" placement="top">[?]</span></label>
                            <b-form-checkbox id="pago"
                                         v-model="form.pago"
                                         value="1"
                                         unchecked-value="2">
                            </b-form-checkbox>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('pago')" v-if="form.errors.has('pago')"></b-form-feedback>
                        </b-col>
                        <b-col cols="2">
                            <label for="dt_recebimento">Data Recebimento<span v-b-tooltip title="Data de recebimento do pagamento" placement="top">[?]</span></label>
                            <v-date-picker v-model="form.dt_recebimento"
                                           mode='single'
                                           locale="pt-BR"
                                           v-mask="'##/##/####'"
                                           :popover='{visibility: "focus"}'
                                           :attributes='date_attributes'
                                           :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                           >
                            </v-date-picker>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('dt_recebimento')" v-if="form.errors.has('dt_recebimento')"></b-form-feedback>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <label for="centro_custo">Centro de custo <span v-b-tooltip title="Utilizado para vincular a setores as despesas" placement="top">[?]</span></label>
                              <multiselect v-model="form.centro_custo"
                              :options="optionsCentroCusto"
                              track-by="value"
                              label="label"
                              id="centro_custo"
                              :hide-selected="true"
                              placeholder="Selecione"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('centro_custo.value')" v-if="form.errors.has('centro_custo.value')"></b-form-feedback>
                        </b-col>
                        <b-col>
                            <label for="num_doc">Nº Documento <span v-b-tooltip title="Nº Documento para identificar a despesa" placement="top">[?]</span></label>
                           <b-form-input type="text"
                                        id="num_doc"
                                       placeholder="Nº Documento"
                                       v-model="form.num_doc">
                           </b-form-input>
                           <b-form-feedback class="text-danger" v-text="form.errors.get('num_doc')" v-if="form.errors.has('num_doc')"></b-form-feedback>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6" v-if="modal_acao=='i'">
                            <label for="cliente">Cliente * <span v-b-tooltip title="Cliente que será vinculado a despesa" placement="top">[?]</span></label>
                          <multiselect v-model="form.pessoa"
                          :options-limit="300"
                          :limit="2"
                          :limit-text="limitText"
                          :options="optionsPessoa"
                          track-by="value"
                          label="label"
                          id="cliente"
                          :hide-selected="true"
                          placeholder="Cliente ( Digite 3 caracteres para pesquisar )"
                          tag-placeholder="Selecionar"
                          select-label="Selecionar"
                          selected-label="Selecionado"
                          deselect-label="Remover"
                          :searchable="true"
                          :loading="isLoadingPessoa"
                          @search-change="listaClientesPessoa"
                          ></multiselect>
                          <b-form-feedback class="text-danger" v-text="form.errors.get('pessoa.value')" v-if="form.errors.has('pessoa.value')"></b-form-feedback>
                        </b-col>

                        <b-col cols="12" v-if="modal_acao=='u'">
                            <label for="pessoa">Cliente <span v-b-tooltip title="Não pode ser alterado" placement="top">[?]</span></label>
                            {{ form.pessoa_razao_social }}
                            <b-form-feedback class="text-danger" v-text="form.errors.get('pessoa.value')" v-if="form.errors.has('pessoa.value')"></b-form-feedback>
                        </b-col>

                        <b-col cols="3" v-if="modal_acao=='i'">
                            <label for="recorrencia">Recorrência <span v-b-tooltip title="A despesa será replicada para meses futuros" placement="top">[?]</span></label>
                          <multiselect v-model="form.recorrencia"
                          :options="optionsLivRecorrencia"
                          track-by="value"
                          id="recorrencia"
                          label="label"
                          :hide-selected="true"
                          placeholder="Selecione"
                          tag-placeholder="Selecionar"
                          select-label="Selecionar"
                          selected-label="Selecionado"
                          deselect-label="Remover"
                          ></multiselect>
                          <b-form-feedback class="text-danger" v-text="form.errors.get('recorrencia.value')" v-if="form.errors.has('recorrencia.value')"></b-form-feedback>
                        </b-col>

                        <b-col v-if="modal_acao=='i'">
                            <label for="qtde_recorrencia">Quantidade recorrência <span v-b-tooltip title="Quantidade Recorrência" placement="top">[?]</span></label>
                           <b-form-input type="text"
                                       placeholder="Quantidade recorrência"
                                       id="qtde_recorrencia"
                                       v-model.lazy="form.qtde_recorrencia">
                           </b-form-input>
                           <b-form-feedback class="text-danger" v-text="form.errors.get('qtde_recorrencia')" v-if="form.errors.has('qtde_recorrencia')"></b-form-feedback>
                        </b-col>

                    </b-row>
                    <b-row>
                        <b-col>
                            <label for="obs">Observação <span v-b-tooltip title="Observação da despesa" placement="top">[?]</span></label>
                            <b-form-textarea id="obs"
                                             v-model="form.obs"
                                             placeholder="Observação"
                                             :rows="3"
                                             :max-rows="6">
                            </b-form-textarea>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('obs')" v-if="form.errors.has('obs')"></b-form-feedback>
                        </b-col>
                    </b-row>
                </b-container>
            </form>
            <div slot="modal-footer" class="w-100">
                <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner>
                </div>
                <div class="float-right">
                    <div class="float-left pr-1" v-if="this.errors_array.length>0">
                      <b-btn class="btn btn-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle"></i></b-btn>

                      <b-popover :show.sync="showPopover" target="popoverButton-sync" title="<strong>Erros Encontrados</strong>" data-html="true" placement="leftbottom">
                        <table class="table" id="mais">
                             <tbody>
                                 <tr style="display: table-row;" v-for="item in this.errors_array">
                                    <td>
                                      {{ item.erro }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                      </b-popover>
                    </div>

                    <b-btn @click="showModal=false" variant="secondary">
                        Fechar
                    </b-btn>
                    <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                        Enviar
                    </b-btn>
                </div>
            </div>
        </b-modal>

            <!-- Modal Component -->
            <b-modal id="modal_form_faturar"
                     ref="modal_form_faturar"
                     size="lg"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     v-model="showModalFaturar"
                     :ok-disabled=form.errors.any()
                 @ok="storeFaturar">
                <form @submit.stop.prevent="storeFaturar" @keydown="form_faturar.errors.clear($event.target.name)">
                    <b-container fluid class="p-a-0">
                        <b-row>
                            <b-col>
                                <label for="dt_recebimento">Data Recebimento <span v-b-tooltip title="Data de recebimento do pagamento" placement="top">[?]</span></label>
                                <v-date-picker v-model="form_faturar.dt_recebimento"
                                               mode='single'
                                               locale="pt-BR"
                                               v-mask="'##/##/####'"
                                               :popover='{visibility: "focus"}'
                                               :attributes='date_attributes'
                                               :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                               >
                                </v-date-picker>
                                <b-form-feedback class="text-danger" v-text="form_faturar.errors.get('dt_recebimento')" v-if="form.errors.has('dt_recebimento')"></b-form-feedback>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                Obs: Se não for informada a data, será utilizada a data do dia
                            </b-col>
                        </b-row>
                    </b-container>
                </form>
                <div slot="modal-footer" class="w-100">
                    <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner>
                    </div>
                    <div class="float-right">
                       <div class="float-left" v-if="this.errors_array.length>0">
                          <b-btn class="label label-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle"></i></b-btn>

                          <b-popover :show.sync="showPopover" target="popoverButton-sync" title="<strong>Erros Encontrados</strong>" data-html="true" placement="leftbottom">
                            <table class="table" id="mais">
                                 <tbody>
                                     <tr class="bg-gray-light" style="display: table-row;" v-for="item in this.errors_array">
                                        <td>
                                          {{ item.erro }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                          </b-popover>
                        </div>
                        &nbsp;

                        <b-btn @click="showModalFaturar=false" variant="secondary">
                          Fechar
                        </b-btn>
                        <b-btn @click="storeFaturar()" variant="secondary" :disabled="isDisabled">
                          Enviar
                        </b-btn>
                    </div>
                </div>
            </b-modal>
        </section>
    </div>
</template>
<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import DespesaFilterBar from './DespesaFilterBar'
import moment from 'moment'
import accounting from 'accounting'
import {VMoney} from 'v-money'
import DespesaDetalhes from './DespesaDetalhes'

Vue.component('despesa-detalhes', DespesaDetalhes);

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        'vuetable-filterbar': DespesaFilterBar,
        VMoney,
    },
    data () {
        return {
          dataExport: [],
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          showPopover: false,
          isLoadingPessoa: false,
          loading: false,
          isDisabled: false,
          loadingData: true,
          showModal: false,
          showModalFaturar: false,
          showModalHelp: false,
          isFullscreen: false,
          optionsLivRecorrencia: [],
          optionsCentroCusto: [],
          optionsContaContabil: [],
          optionsDespesaPai: [],
          optionsUnidadeConta: [],
          optionsPessoa: [],
          despesaRecord: [],
          errors_array: [],
          date_attributes: [{key: 'today',highlight: true,dates: new Date()}],
          form: new Form({ descr: '',
                           vlr: '',
                           status: [],
                           dt_competencia: '',
                           dt_vencto: '',
                           dt_recebimento: '',
                           pago: '',
                           obs: '',
                           num_doc: '',
                           recorrencia: [],
                           qtde_recorrencia: '',
                           pessoa: [],
                           unidade_conta: [],
                           despesa_pai: [],
                           conta_contabil: [],
                           centro_custo: [],
                           pessoa_razao_social: '',
                           despesa_id: ''
                       }),
         form_faturar: new Form({ despesaRecord: [],
                            dt_recebimento: '',
                        }),
         form_cancelar: new Form({ despesaRecord: []
                        }),
         aliquota: {
             decimal: ',',
             prefix: '% ',
             precision: 2,
             masked: false /* doesn't work with directive */
         },
         vlr: {
             decimal: ',',
             thousands: '.',
             prefix: 'R$ ',
             precision: 2,
             masked: false /* doesn't work with directive */
         },
         helpForm: new Form({statusRecord: [], params: [],search:'', status: ''}),
         fields: [
          {
              name: '__checkbox',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          },
          {
            name: 'num_titulo',
            title: 'N° Título',
            sortField: 'num_titulo'
          },
          {
            name: '__slot:pessoa',
            title: 'Cliente',
            sortField: 'pessoa'
          },
          {
            name: '__slot:tp_pessoa',
            title: 'Tipo',
          },
          {
            name: '__slot:conta_bancaria',
            title: 'Conta Bancária',
          },
          {
            name: '__slot:conta_contabil',
            title: 'Conta Contábil',
          },
          {
            name: 'descr',
            title: 'Descrição',
            sortField: 'descr'
          },
          {
            name: 'vlr',
            title: 'Valor',
            callback: 'formatNumber'
          },
          {
            name: 'dt_vencto',
            title: 'Data Prevista',
            callback: 'formatDate|DD/MM/YYYY'
          },
          {
            name: '__slot:status',
            title: 'Status',
            sortField: 'status'
          },
          {
              name: '__slot:actions',   // <----
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          }
      ],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
       }
    },
    directives: {
        money: VMoney,
        aliquota: VMoney,
        qtd: VMoney,
        percentual_reducao_bc: VMoney
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
        this.getLivGeral();
      },

    methods: {
        expandFullscreen() {
            this.isFullscreen = !this.isFullscreen;
        },
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.loadingData = true;
            this.moreParams = {
                'num_titulo': data_filter.num_titulo,
                'cnpj': data_filter.cnpj,
                'dt_inicio': data_filter.dt_inicio,
                'dt_fim': data_filter.dt_fim,
                'status': data_filter.status.value
            }
            Vue.nextTick( () => {this.$refs.vuetable.reload(); })
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.despesa_id);
        },
        onShowHelp() {
            this.modal_titulo = "Ajuda";
            this.modal_acao = "i";
            this.showModalHelp = true;
        },
        handleOk(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStore();
            }
            else
            {
                this.onUpdate(this.form.despesa_id);
            }
        },
        onFaturar(tp_selecao, data)
        {
            this.isDisabled = false;
            this.loading = false;
            this.modal_titulo = "Faturar";
            this.modal_botao = "Faturar";
            this.modal_acao = "i";
            this.form_faturar.reset();

            // Tipo = true = Checkbox
            if(tp_selecao==1)
            {
                this.despesaRecord = [];
                this.despesaRecord.push({ id: data.despesa_id });
            }
            else
            {
                this.despesaRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.despesaRecord.push({ id: obj })
                });
            }

            this.form_faturar.despesaRecord = this.despesaRecord;

            this.errors_array = '';
            this.errors_array = [];
            this.$refs.modal_form_faturar.show();
        },
        onCreate ()
        {
          this.isDisabled = false;
          this.loading = false;
          this.modal_titulo = "Cadastrar";
          this.modal_botao = "Cadastrar";
          this.modal_acao = "i";
          //this.form.reset();
          this.errors_array = '';
          this.errors_array = [];
          this.$refs.modal_form.show();
        },
        onEdit (data, index)
        {
            this.isDisabled = false;
            this.loading = false;
            this.modal_titulo = "Alterar Lançamento";
            this.modal_botao = "Alterar Lançamento";
            this.modal_acao = "u";
            this.form.reset();
            this.errors_array = '';
            this.errors_array = [];
            this.form.despesa_id = data.despesa_id;
            this.form.descr = data.descr;
            this.form.vlr = this.formatNumber(data.vlr);
            if(data.dt_vencto!=null)
            {
                this.form.dt_competencia = new Date(data.dt_competencia);
            }
            if(data.dt_vencto!=null)
            {
                this.form.dt_vencto = new Date(data.dt_vencto);
            }
            this.form.obs = data.obs;
            this.form.num_doc = data.num_doc;
            this.form.centro_custo = { label: data.centro_custo.descr, value: data.centro_custo.cencus_id };
            this.form.conta_contabil = { label: data.conta_contabil.descr, value: data.conta_contabil.concon_id };
            this.form.unidade_conta = { label: data.unidade_conta.descr, value: data.unidade_conta.unicon_id };
            if(data.pessoa.pessoa_juridica!==null)
            {
                this.form.pessoa_razao_social = data.pessoa.pessoa_juridica.razao_social;
            }
            else if(data.pessoa.pessoa_fisica!==null)
            {
                this.form.pessoa_razao_social = data.pessoa.pessoa_fisica.nome;
            }
            else if(data.pessoa.pessoa_outro!==null)
            {
                this.form.pessoa_razao_social = data.pessoa.pessoa_outro.nome;
            }
            this.$refs.modal_form.show();
        },
        onCancelar(tp_selecao, data) {

            // Tipo = true = Checkbox
            if(tp_selecao==1)
            {
                this.despesaRecord = [];
                this.despesaRecord.push({ id: data.despesa_id });
            }
            else
            {
                this.despesaRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.despesaRecord.push({ id: obj })
                });
            }

            let form = this.form_cancelar;
            var vm = this;
            var despesaRecord = this.despesaRecord;
            const onConfirmarCancelarWrapper = () => {
                confirmCancelarFn(vm, despesaRecord);
            }

            let confirmCancelarFn = function(vm, despesa_id) {
                vm.form_cancelar.despesaRecord = despesaRecord;
                vm.form_cancelar.post('/api/despesa/cancelar').then(response =>
                {
                    new ReturnApi(response, vm)
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, vm)
                });
            }

            let obj = {
                title: 'Você deseja cancelar o titulo ?',
                message: 'Esta ação é irreversível',
                customConfirmBtnText: 'Sim',
                customCloseBtnText: 'Não',
                type: 'info',
                useConfirmBtn: true,
                onConfirm: onConfirmarCancelarWrapper
            }

            this.$Simplert.open(obj);
        },
        onStore()
        {
            this.loading = true;
            this.isDisabled = true;
            this.form.dt_vencto = this.formatDateSubmit(this.form.dt_vencto);
            this.form.dt_competencia = this.formatDateSubmit(this.form.dt_competencia);
            this.form.dt_recebimento = this.formatDateSubmit(this.form.dt_recebimento);
            this.form.post('/api/despesa/store').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
                this.errors_array = '';
                this.errors_array = [];
                for(var property in errors)
                {
                  if(errors.hasOwnProperty(property))
                  {
                     if(typeof(errors[property]) === 'object')
                     {
                     errors[property].forEach((obj)=>{
                        this.errors_array.push({erro: obj});
                     });
                     }
                  }
                }
            });
        },
        storeFaturar(e)
        {
            this.loading = true;
            this.isDisabled = true;
            this.form_faturar.dt_recebimento = this.formatDateSubmit(this.form_faturar.dt_recebimento);
            this.form_faturar.post('/api/despesa/faturar').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
                this.errors_array = '';
                this.errors_array = [];
                for(var property in errors)
                {
                  if(errors.hasOwnProperty(property))
                  {
                     if(typeof(errors[property]) === 'object')
                     {
                     errors[property].forEach((obj)=>{
                        this.errors_array.push({erro: obj});
                     });
                     }
                  }
                }
            });
        },
        onUpdate(id)
        {
            this.loading = true;
            this.isDisabled = true;
            this.form.dt_vencto = this.formatDateSubmit(this.form.dt_vencto);
            this.form.dt_competencia = this.formatDateSubmit(this.form.dt_competencia);
            this.form.dt_recebimento = this.formatDateSubmit(this.form.dt_recebimento);
            this.form.post('/api/despesa/update/'+id).then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
              new ReturnApi(errors, this)
              this.errors_array = '';
              this.errors_array = [];
              for(var property in errors)
              {
                if(errors.hasOwnProperty(property))
                {
                   if(typeof(errors[property]) === 'object')
                   {
                   errors[property].forEach((obj)=>{
                      this.errors_array.push({erro: obj});
                   });
                   }
                }
              }
          });
        },
        formatNumberInterno (value) {
            return accounting.formatNumber(value, 2, ',', '.')
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        formatDate(value, fmt = 'DD/MM/YYYY') {
            return (value == null) ?
                '' :
                moment(value, 'YYYY-MM-DD').format(fmt)
        },
        formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
            return (value == null || value == "")
              ? ''
              : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
        },
        expandFullscreen() {
            this.isFullscreen = !this.isFullscreen;
        },
        formatTypedDate: function (dateString)
        {
           let result = dateString.split('/')
           return result[2] + '-' + result[1] + '-' + result[0] + 'T00:00:00-03:00'
        },
        getLivGeral() {
            this.helpForm.get('/api/despesa/jsonlistgeral').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.unidade_conta.forEach((obj)=>
                {
                    this.optionsUnidadeConta.push({ label: obj.descr, value: obj.unicon_id })
                })
                response.conta_contabil_despesa.forEach((obj)=>
                {
                    this.optionsContaContabil.push({ label: obj.descr, value: obj.concon_id })
                })
                response.centro_custo.forEach((obj)=>
                {
                    this.optionsCentroCusto.push({ label: obj.descr, value: obj.cencus_id })
                })
                response.recorrencia.forEach((obj)=>
                {
                    this.optionsLivRecorrencia.push({ label: obj.descr, value: obj.valor })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        listaClientesPessoa(search) {
            if(search.length>=3)
            {
                this.isLoadingPessoa = true;
                this.helpForm.search = search;
                this.helpForm.status = 1;
                this.helpForm.post('/api/pessoa/jsonlist/cliente').then(response =>
                {
                    this.optionsPessoa = [];
                    new ReturnApi(response, this, true, false, false);
                    response.items.forEach((obj)=>
                    {
                        this.optionsPessoa.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    response.itemsF.forEach((obj)=>
                    {
                        this.optionsPessoa.push({ label: obj.nome+" - "+obj.cpf, value: obj.pessoa_id })
                    });
                    response.itemsO.forEach((obj)=>
                    {
                        this.optionsPessoa.push({ label: obj.nome+" - "+obj.cd, value: obj.pessoa_id })
                    });
                    this.isLoadingPessoa = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                  });
              }
          },
          listaClientesFornecedor(search)
          {
              if(search.length>=3)
              {
                  this.isLoadingFor = true;
                  this.helpForm.search = search;
                  this.helpForm.post('/api/pessoa/jsonlist/fornecedor').then(response =>
                  {
                      this.optionsFornecedor = [];
                      new ReturnApi(response, this, true, false, false);
                      response.items.forEach((obj)=>
                      {
                          this.optionsFornecedor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                      });
                      this.isLoadingFor = false;
                  })
                  .catch(errors =>
                  {
                      new ReturnApi(errors, this)
                    });
                }
        },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito)
        {
            var cnpj_formatado
            var pad = "00000000"
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.length) + cnpj_digito;

            return cnpj_base+""+cnpj_filial+""+cnpj_digito;
        },
        nome(nome, nome_social) {
            if(nome_social!==null)
            {
                return nome_social;
            }
            else
            {
                return nome;
            }
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        vuetableFilterRow: {
          get () {
            return this.$store.state.vuetable.filterRow;
          },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
  }
  </script>
